import api from "../axios";


/*
|--------------------------------------------------------------------------
| GET PRICING PLANS FOR OFFERING
|--------------------------------------------------------------------------
|
| GET /api/pricing-plans/offering/:offeringId
|
*/

export const getPricingPlansApi = (
  offeringId,
  activeOnly = true
) => {
  return api.get(
    `/pricing-plans/offering/${offeringId}`,
    {
      params: {
        activeOnly
      }
    }
  );
};


/*
|--------------------------------------------------------------------------
| GET SINGLE PRICING PLAN
|--------------------------------------------------------------------------
*/

export const getPricingPlanApi = (
  id
) => {
  return api.get(
    `/pricing-plans/${id}`
  );
};


/*
|--------------------------------------------------------------------------
| CREATE PRICING PLAN
|--------------------------------------------------------------------------
*/

export const createPricingPlanApi = (
  offeringId,
  data
) => {
  return api.post(
    `/pricing-plans/offering/${offeringId}`,
    data
  );
};


/*
|--------------------------------------------------------------------------
| UPDATE PRICING PLAN
|--------------------------------------------------------------------------
*/

export const updatePricingPlanApi = (
  planId,
  data
) => {
  return api.patch(
    `/pricing-plans/${planId}`,
    data
  );
};


/*
|--------------------------------------------------------------------------
| DELETE PRICING PLAN
|--------------------------------------------------------------------------
*/

export const deletePricingPlanApi = (
  planId
) => {
  return api.delete(
    `/pricing-plans/${planId}`
  );
};